import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=00d4539d&scoped=true"
import script from "./Sync.vue?vue&type=script&lang=ts"
export * from "./Sync.vue?vue&type=script&lang=ts"
import style0 from "./Sync.vue?vue&type=style&index=0&id=00d4539d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4539d",
  null
  
)

export default component.exports